import { RemoteGetAllActivitiesByGroup } from 'data/usecases/dashboard';
import { GetAllActivitiesByGroup } from 'domain/usecases/dashboard';
import { makeApiUrlActivitiesByGroup } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetAllActivitiesByGroup = (): GetAllActivitiesByGroup =>
  new RemoteGetAllActivitiesByGroup(
    makeApiUrlActivitiesByGroup(),
    makeAxiosHttpClient(),
  );
